export default __webpack_public_path__ + "static/media/software posters (1).b6b68469.webp";